<template>
  <div class="breadBox">
    <div class="bread" v-if="$store.state.showBreadcrumb">
      <el-breadcrumb
        class="app-breadcrumb"
        separator="/"
        separator-class="el-icon-arrow-right"
      >
        <transition-group name="breadcrumb">
          <el-breadcrumb-item
            v-for="(item, index) in levelList"
            :key="item.path"
          >
            <span
              class="no-redirect"
              v-if="index === 0"
              style="margin-right:10px"
              >您的位置:</span
            >
            <span
              v-if="
                item.redirect === 'noRedirect' || index == levelList.length - 1
              "
              class="no-redirect"
              >{{ item.meta.title }}</span
            >
            <a v-else @click.prevent="handleLink(item)">{{
              item.meta.title
            }}</a>
          </el-breadcrumb-item>
        </transition-group>
      </el-breadcrumb>
    </div>
  </div>
</template>

<script>
import pathToRegexp from "path-to-regexp";

export default {
  data() {
    return {
      levelList: null,
    };
  },
  watch: {
    $route(newValue) {
      if (newValue) {
        this.changeShowState();
      }
      this.getBreadcrumb();
    },
  },
  created() {
    this.changeShowState();
    this.getBreadcrumb();
  },
  methods: {
    changeShowState() {
      let showState = this.$route.meta.showBread ? true : false;
      this.$store.commit("changeShowBreadcrumbState", showState);
    },
    getBreadcrumb() {
      // only show routes with meta.title
      let matched = this.$route.matched.filter(
        (item) => item.meta && item.meta.title
      );
      const first = matched[0];

      if (!this.isDashboard(first)) {
        matched = [{ path: "/", meta: { title: "首页" } }].concat(matched);
      }

      this.levelList = matched.filter(
        (item) => item.meta && item.meta.title && item.meta.breadcrumb !== false
      );
    },
    isDashboard(route) {
      const name = route && route.name;
      if (!name) {
        return false;
      }
      return name.trim().toLocaleLowerCase() === "Home".toLocaleLowerCase();
    },
    pathCompile(path) {
      // To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
      const { params } = this.$route;
      var toPath = pathToRegexp.compile(path);
      return toPath(params);
    },
    handleLink(item) {
      console.log(item);
      const { redirect, path } = item;
      if (redirect) {
        this.$router.push(redirect);
        return;
      }
      this.$router.push(this.pathCompile(path));
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/static/styles/variables.less";
.breadBox {
  width: 100vw;
  min-width: @commentWidth;
  background: #f7f7f7;
  // padding: 30px 0;
}
.bread {
  width: @defaultWidth;
  max-width: @maxWidth;
  margin: 0 auto;
  padding: 30px 0;
}
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 50px;
  a {
    color: @breadTextColor;
    font-size: 16px;
    font-family: PingFang-SC-Bold, PingFang-SC;
    font-weight: bold;
    color: #a1a1a1ff;
    line-height: 22px;
  }
  a:hover {
    color: @mainColor;
    cursor: pointer;
  }
  .no-redirect {
    color: @breadTextColor;
    cursor: text;
    font-size: 16px;
    font-family: PingFang-SC-Bold, PingFang-SC;
    font-weight: bold;
    color: #a1a1a1ff;
    line-height: 22px;
  }
}
.bread_label {
  display: inline-block;
}
.bread_text {
  color: #e69494;
  font-size: 14px;
  line-height: 50px;
}
</style>
<style lang="less">
.bread {
  .el-icon-arrow-right:before {
    font-weight: bold;
    color: #a1a1a1ff;
    line-height: 22px;
  }
}
</style>
